export { default } from './StatusLabel'
